import React, {useState} from 'react'
import ReactDOM from 'react-dom';
import { useSelector, useDispatch } from 'react-redux'

import Waiting from './Waiting';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import useStyles from '../styles/Styles'

import { setPayPalSdkError, capturePayPalPayment } from '../actions'; 

import _ from 'lodash';

const PayPalButton = ({invoiceNo}) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	
	const user = useSelector(state => state.user);
	const generalSettings = useSelector(state => state.settings.general.data);
	const sdkLoaded = useSelector(state => state.payPalSdkLoaded);
	const payPalError = useSelector(state => state.payPalSdkError);
	
	const invoice = useSelector(state => state.invoices.data[invoiceNo]);
	const invoiceInfo = useSelector(state => state.invoices.singles[invoiceNo]);

	const [initialised, setInitialised] = useState(false);

  // NOT currently doing tax breakdown, but could do:
  // https://developer.paypal.com/docs/api/orders/v2/ 

	const createPPOrder = (data, actions) => {
		return actions.order.create({
			purchase_units: [{
				amount: {
					value: _.toNumber(invoice.due),
					breakdown: {
						item_total: {
							value: _.toNumber(invoice.due),
							currency_code: 'AUD'
						}
					}
				},
				description: generalSettings.formal_name + ' invoice ' + user.member_no + '-' + invoiceNo,
				soft_descriptor: user.member_no + '-' + invoiceNo,
				invoice_id: user.member_no + '-' + invoiceNo,
				reference_id: invoiceNo,
				custom_id: user.member_no,
				items: _.chain(invoice.line_items).filter(i => {
						return _.toNumber(i.amount) > _.toNumber(i.amount_paid) && i.status !== 'Waitlist'
					}).map(i => {
						return {
							name: i.course_code,
							unit_amount: {
								value: _.toNumber(i.amount) - _.toNumber(i.amount_paid),
								currency_code: 'AUD'
							},
							quantity: 1,
							description: i.name,
							category: 'DIGITAL_GOODS'
						}
					}).value()
			}]
		})
	}
	
	const onPPApprove = (data, actions) => {
		dispatch(capturePayPalPayment(data.orderID, invoiceNo));
	}
	
	const onPPInit = (data, actions) => {
		setInitialised(true);
	}
	
	const onPPError = (err) => {
		console.log('PayPal error', err)
		dispatch(setPayPalSdkError(true));
	}
	
	if(!sdkLoaded || _.isNil(invoiceInfo) || (invoice && _.toNumber(invoice.due) <= 0)){
		return <></>;
	} else if(invoiceInfo.submitting){
		return  <Waiting />
	} else if(invoiceInfo.error){
		return <Typography>{invoiceInfo.error}</Typography>
	} else if(payPalError){
		return <Typography>PayPal error: PayPal payment is currently unavailable.</Typography>
	} else {
		let PPB = window.paypal.Buttons.driver('react', { React, ReactDOM });
		const payButton = <PPB 
			style={{ 
				layout: 'horizontal',
				label: 'pay',
				tagline: false,
				height: 38,
			}}
			createOrder={ (data, actions) => createPPOrder(data, actions) }
			onApprove={ (data, actions) => onPPApprove(data, actions) }
			onInit={ (data, actions) => onPPInit(data, actions) }
			onError={ err =>  onPPError(err) }
			/>

		return <div id={'PayPalButton_'+invoiceNo} className={classes.PayPalButton} >
			<Box
				component='div'
				sx={{ display: { xs: initialised ? 'initial' : 'none' } }}
			>{payButton}</Box>
			</div>
	}
	
}

export default PayPalButton

/*
data like:
{
  "orderID": "36179935HV558673M",
  "payerID": "FEB4ENL5VYHX2",
  "paymentID": null,
  "billingToken": null,
  "facilitatorAccessToken": "A21AAEB3cDhkeHxn_vWM7uevtPS2ytK8jRWZOq7LdTRuaTpObJIA7_kll77Ka8GiPlNhAgmHawdI-haowvmihVEhIYdkj0pig"
}
	
	
details like: 
	
{
  "create_time": "2020-02-27T11:22:00Z",
  "update_time": "2020-02-27T11:22:18Z",
  "id": "36179935HV558673M",
  "intent": "CAPTURE",
  "status": "COMPLETED",
  "payer": {
    "email_address": "paypaltest@barbendingdesigns.com",
    "payer_id": "FEB4ENL5VYHX2",
    "address": {
      "country_code": "AU"
    },
    "name": {
      "given_name": "Test",
      "surname": "Customer"
    }
  },
  "purchase_units": [
    {
      "reference_id": "1412-2011",
      "custom_id": "1412",
      "invoice_id": "2011",
      "amount": {
        "value": "5.00",
        "currency_code": "AUD"
      },
      "payee": {
        "email_address": "business@barbendingdesigns.com",
        "merchant_id": "W896HVXJRSMRQ"
      },
      "shipping": {
        "name": {
          "full_name": "Test Customer"
        },
        "address": {
          "address_line_1": "1 Cheeseman Ave Brighton East",
          "admin_area_2": "Melbourne",
          "admin_area_1": "Victoria",
          "postal_code": "3001",
          "country_code": "AU"
        }
      },
      "payments": {
        "captures": [
          {
            "status": "COMPLETED",
            "id": "56H42598K39518542",
            "invoice_id": "2011",
            "final_capture": true,
            "create_time": "2020-02-27T11:22:18Z",
            "update_time": "2020-02-27T11:22:18Z",
            "amount": {
              "value": "5.00",
              "currency_code": "AUD"
            },
            "seller_protection": {
              "status": "ELIGIBLE",
              "dispute_categories": [
                "ITEM_NOT_RECEIVED",
                "UNAUTHORIZED_TRANSACTION"
              ]
            },
            "links": [
              {
                "href": "https://api.sandbox.paypal.com/v2/payments/captures/56H42598K39518542",
                "rel": "self",
                "method": "GET",
                "title": "GET"
              },
              {
                "href": "https://api.sandbox.paypal.com/v2/payments/captures/56H42598K39518542/refund",
                "rel": "refund",
                "method": "POST",
                "title": "POST"
              },
              {
                "href": "https://api.sandbox.paypal.com/v2/checkout/orders/36179935HV558673M",
                "rel": "up",
                "method": "GET",
                "title": "GET"
              }
            ]
          }
        ]
      }
    }
  ],
  "links": [
    {
      "href": "https://api.sandbox.paypal.com/v2/checkout/orders/36179935HV558673M",
      "rel": "self",
      "method": "GET",
      "title": "GET"
    }
  ]
}
*/